export default "__VITE_ASSET__DT8p3VIG__"